import React from 'react';
import { IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { colors } from '@styles/colors';

/**
 * Botón de consulta con icono de búsqueda (barra de filtros).
 * @param {function} onClick - Acción al pulsar (ej. consultar / filtrar).
 * @param {boolean} [disabled=false]
 * @param {string} [titulo='Buscar'] - Texto para `title` y `aria-label` (accesibilidad).
 * @param {boolean} [varianteFiltros=true] - `true`: mismo criterio visual que filtros alineados (radio/padding con inputs).
 *   `false`: botón cuadrado compacto (p. ej. CitasExtras, ServiciosAdmin, Programar).
 */
function BotonBuscar({
  onClick,
  disabled = false,
  titulo = 'Buscar',
  varianteFiltros = true,
}) {
  const estiloBase = {
    backgroundColor: colors.primary,
    color: colors.white,
  };

  const estilo = varianteFiltros
    ? {
        ...estiloBase,
        marginTop: 'auto',
        alignSelf: 'flex-start',
        borderRadius: '8px',
        height: '5vh',
        width: '5vh',
        padding: '1.4vh',
        border: `2px solid ${colors.primary}`,
      }
    : {
        ...estiloBase,
        borderRadius: '8px',
        height: '5vh',
        width: '5vh',
      };

  return (
    <IconButton
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={titulo}
      aria-label={titulo}
      style={estilo}
    >
      <SearchIcon style={{ fontSize: '4vh' }} />
    </IconButton>
  );
}

export default BotonBuscar;
